// extracted by mini-css-extract-plugin
export default {"container":"Empty_container__lDnN6","icon__container":"Empty_icon__container__ew5Mb","text__container":"Empty_text__container__qMHPV","text":"Empty_text__a9M9F"};